export function getCookie(name) {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${name?.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1")}=([^;]*)`
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setCookie(name, value, path, expires) {
  if (expires === undefined) {
    document.cookie = `${name}=${value}; path=${path};`;

    return;
  }
  document.cookie = `${name}=${value}; path=${path}; expires=${expires};`;
}
